import { memo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from '../../constants';

import InputPanelCloseButtonV1 from './InputPanelCloseButtonV1';

export interface InputPanelHeaderV1Properties {
  title: string;
  onClose: () => void;
}

const InputPanelHeaderV1 = memo(({ title, onClose }: InputPanelHeaderV1Properties) => (
  <Flex align='center' justify='space-between' w='100%' flexShrink={0}>
    <Text
      fontFamily='Comfortaa Bold'
      fontSize={BUILDER_MODE_V1_LAYOUT.inputPanelTitleFontSize}
      fontWeight='700'
      lineHeight='normal'
      color={BUILDER_MODE_V1_TOKENS.textDark}
      noOfLines={1}
      wordBreak='break-word'
    >
      {title}
    </Text>
    <InputPanelCloseButtonV1 onClick={onClose} />
  </Flex>
));

InputPanelHeaderV1.displayName = 'InputPanelHeaderV1';

export default InputPanelHeaderV1;
